import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DatePipe, NgIf } from '@angular/common';
import { Router } from '@angular/router';
import { OwnerType } from '../paywall.models';

@Component({
    selector: 'quota-exceeded-dialog',
    templateUrl: './quota-exceeded-dialog.component.html',
    imports: [MatDialogModule, MatButtonModule, MatIconModule, MatProgressBarModule, DatePipe, NgIf],
})
export class QuotaExceededDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<QuotaExceededDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {
            feature: string;
            resetsAt: string;
            used: number;
            limit: number;
            ownerType: OwnerType;
        },
        private _router: Router,
    ) {}

    goToUpgrade(): void {
        this.dialogRef.close();
        const route = this.data.ownerType === 'tenant' ? '/tenant/paywall' : '/paywall';
        this._router.navigate([route], { queryParams: { tab: 'plans' } });
    }
}
